/**
 * ! Api Query Lists !
 */
export const useQuery = () => {
  const getOrderTypeQuery = (type: 'group' | 'order') => {
    const searchParams = new URLSearchParams([['type', type]]).toString()

    return '?' + searchParams
  }
  const getPlanNameQuery = (planName: string) => {
    const searchParams = new URLSearchParams([['planName', planName]]).toString()

    return '?' + searchParams
  }

  const getPlanIdQuery = (planId: string) => {
    const searchParams = new URLSearchParams([['planId', planId]]).toString()

    return '?' + searchParams
  }

  const getEventReplyQuery = (page: string, take: string) => {
    const searchParams = new URLSearchParams([
      ['page', page],
      ['take', take]
    ]).toString()

    return '?' + searchParams
  }

  return { getOrderTypeQuery, getPlanNameQuery, getPlanIdQuery, getEventReplyQuery }
}
